import { Observable } from 'rxjs';
import { PreviewError } from './preview-error';
import { PreferredMediaDevices } from './media-devices';

export abstract class VideoConferenceProvider {
  abstract name: string;

  abstract toggleVideo(): Promise<void>;

  abstract toggleSound(): Promise<void>;

  abstract join(): Promise<void>;

  abstract left(): Promise<void>;

  abstract features(): string[];

  abstract getRemoteParticipants(): (string | number)[];

  abstract remoteVideoObservable: Observable<boolean>;
  abstract remoteAudioObservable: Observable<boolean>;

  abstract localVideoObservable: Observable<boolean>;
  abstract localAudioObservable: Observable<boolean>;

  abstract remoteFallbackObservable: Observable<boolean>;

  abstract previewErrorObservable: Observable<PreviewError | null>;

  abstract localMicVolumeObservable: Observable<number>;

  abstract devicesChangedObservable: Observable<void>;

  abstract createLocalPreviewTracks(): Promise<void>;

  abstract stopLocalPreview(): Promise<void>;

  abstract listCameras(): Promise<MediaDeviceInfo[]>;

  abstract listMicrophones(): Promise<MediaDeviceInfo[]>;

  abstract listSpeakers(): Promise<MediaDeviceInfo[]>;

  abstract switchCamera(deviceId: string): Promise<void>;

  abstract switchMicrophone(deviceId: string): Promise<void>;

  abstract switchSpeaker(deviceId: string): void;

  abstract setPreferredDevices(devices: PreferredMediaDevices): void;

  abstract getActiveDevices(): PreferredMediaDevices;

  abstract setLocalVideoContainer(container: HTMLElement | null): void;
}
